import styled from 'styled-components';

export const FullWidthWrapper = styled.div`
  canvas {
    width: 100% !important;
    height: auto !important;
  }
`;
